var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.isActive ? 'splash-screen__img-active' : 'splash-screen__img-inactive',attrs:{"src":_vm.imgUrl},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }